import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { Tooltip } from '@src/components/Tooltip';
import frChatSvg from '@src/svgs/fr-speech-bubble.svg';
import { Props } from './props';
import './styles.scss';

export const Message: FC<Props> = ({ isUserVerified, hasRecruiterMessaged, onMessageClick }) => {
  if (isUserVerified) {
    return (
      <div className={'talent-feed-item-actions__item'} onClick={onMessageClick}>
        <Svg
          className={classnames(
            'talent-feed-item-actions__icon',
            hasRecruiterMessaged && 'talent-feed-item-actions-icon-active',
          )}
          src={frChatSvg}
        />
        <span>Message</span>
      </div>
    );
  }

  return (
    <Tooltip disable={isUserVerified} placement="top" overlay={<span>Talent has hidden their profile.</span>}>
      <div className="talent-feed-item-actions__item talent-feed-item-actions__item--disabled">
        <Svg
          className={classnames(
            'talent-feed-item-actions__icon',
            hasRecruiterMessaged && 'talent-feed-item-actions-icon-active',
          )}
          src={frChatSvg}
        />
        <span>Message</span>
      </div>
    </Tooltip>
  );
};
